import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex flex-col gap-8 sm:mt-5 sm:gap-10',
    section: 'flex flex-col gap-5',
    sectionTitle: 'heading-m-regular',
    quantity: 'w-full',
    selectButton: 'w-full'
  },
  variants: {},
  defaultVariants: {}
});
